if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.Request = function () {
    var self = this;

    self.ajax = function (options) {
        $.ajax({
            url: options.url || '/',
            data: options.data || {},
            dataType: options.dataType || 'json',
            type: options.type || 'GET',
            async: options.async || true
        })
                .done(function (response) {
                    if ($.isFunction(options.callback)) {
                        options.callback(response);
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR, textStatus, errorThrown);
                });
    };

    self.get = function (url, data, callback, dataType) {
        self.ajax({
            url: url,
            type: 'GET',
            data: !$.isFunction(data) ? data : {},
            callback: $.isFunction(data) ? data : callback,
            dataType: dataType
        });
    };

    self.post = function (url, data, callback, dataType, async) {
        if ($.isFunction(data)) {
            callback = data;
            data = {};
        }
        
        //var expiresTime = Date.parse(new Date(window.expiresAccessToken));
        //var currentTime = Date.parse(new Date());
        var isRequested = false;
        
        //if (currentTime >= expiresTime || isNaN(expiresTime)) {
        //    refreshToken(next);
        //} else {
            next();
        //}
        
        function next() {
            data.access_token = window.accessToken;
            
            self.ajax({
                url: url,
                type: 'POST',
                data: data,
                callback: function(response) {
                    if (!isRequested && typeof response === 'object' && response.hasOwnProperty('error') && response.error.name === 'access_token_not_found') {
                        isRequested = true;
                        refreshToken(next);
                        return;
                    }
                    
                    callback(response);
                },
                dataType: dataType || 'json',
                async: async || true
            });
        }
    };
    
    function refreshToken(callback) {
        self.ajax({
            url: '/api/companies/tokens/refresh/' + window.accessToken,
            type: 'GET',
            callback: function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error.description);
                    return false;
                }

                window.accessToken = response.access_token;
                window.expiresAccessToken = response.expires;
                callback();
            }
        });
    }
};